import { Duration } from 'luxon';

type Unit = 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year';

function hasWholeValue(v: number): boolean {
    return Math.floor(Math.abs(v)) !== 0;
}

export default function selectValueAndUnit(d: Duration): [number, Unit] {
    const years = d.as('years');
    const months = d.as('months');
    const days = d.as('days');
    const hours = d.as('hours');
    const minutes = d.as('minutes');
    const seconds = d.as('seconds');

    if (hasWholeValue(years)) {
        return [years, 'year'];
    }

    if (hasWholeValue(months)) {
        return [months, 'month'];
    }

    if (hasWholeValue(days)) {
        return [days, 'day'];
    }

    if (hasWholeValue(hours)) {
        return [hours, 'hour'];
    }

    if (hasWholeValue(minutes)) {
        return [minutes, 'minute'];
    }

    return [seconds, 'second'];
}
